import { createAction, handleActions } from 'redux-actions';
import { takeLatest } from 'redux-saga/effects';
import * as apiDashboard from 'apiSaga/apiDashboard';
import createRequestSaga from 'apiSaga/createRequestSaga';

/***** 액션 타입 선언 *****/

// Dashboard Response 초기화
// const INIT_DASHBOARD_RESP = 'dboard/INIT_DASHBOARD_RESP';
// export const initDashboardResp = createAction(INIT_DASHBOARD_RESP);

// U4103. 고객 메뉴 리스트
const INIT_MENU_LIST_RESP = 'dboard/INIT_MENU_LIST_RESP';
const GET_MENU_LIST = 'dboard/GET_MENU_LIST';
const GET_MENU_LIST_SUCCESS = 'dboard/GET_MENU_LIST_SUCCESS';
const GET_MENU_LIST_FAILURE = 'dboard/GET_MENU_LIST_FAILURE';

export const initMenuListResp = createAction(INIT_MENU_LIST_RESP);
export const getMenuList = createAction(GET_MENU_LIST);
const getMenuListSaga = createRequestSaga(GET_MENU_LIST, apiDashboard.getMenuList);

// apiUserSaga
export function* apiDashboardSaga() {
  yield takeLatest(GET_MENU_LIST, getMenuListSaga);
}

// 초기 상태를 선언
// 요청의 로딩 중 상태는 loading 객체에서 관리
const initialState = {
  getMenuListResp: null,
};

const apiDashboardResp = handleActions(
  {
    // 0. Response 초기화
    // [INIT_DASHBOARD_RESP]: (state, action) => ({
    //   getMenuListResp: null,
    // }),
    [INIT_MENU_LIST_RESP]: (state, action) => ({
      getMenuListResp: null,
    }),
    // U4103. 고객 메뉴 리스트
    [GET_MENU_LIST_SUCCESS]: (state, action) => ({
      ...state,
      getMenuListResp: action.payload,
    }),
    [GET_MENU_LIST_FAILURE]: (state, action) => ({
      ...state,
      getMenuListResp: {
        code: 'E999',
        message: action.payload,
      },
    }),
  },
  initialState
);

export default apiDashboardResp;
